import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CQMSDashBoardCalcDispaly } from 'src/app/models/CQMSDashBoardCalcDisplay';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-denominator-patients',
  templateUrl: './denominator-patients.component.html',
  styleUrls: ['./denominator-patients.component.css']
})
export class DenominatorPatientsComponent implements OnInit {

  displayedColumns: string[] = ['pid', 'pname', 'dob',];
  dataSource =  new MatTableDataSource();

  constructor(
    public dialogRef: MatDialogRef<DenominatorPatientsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CQMSDashBoardCalcDispaly) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  ngOnInit() {
    this.loadDenominatorPats();
  }

  loadDenominatorPats(){
    this.dataSource.data = this.data.patDenominatorList;
  }

}
